import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import { Home, Search, Map, Star, User, Plus, MapPinned, Layers } from 'lucide-react';
import { useEffect, useState } from 'react';
import { APP_NAME } from '../lib/lieux';
import { api } from '../lib/api';

const LIENS = [
  { to: '/dashboard', label: 'Accueil', icon: Home },
  { to: '/recherche', label: 'Recherche', icon: Search },
  { to: '/carte', label: 'Carte', icon: Map },
  { to: '/favoris', label: 'Favoris', icon: Star },
  { to: '/profil', label: 'Profil', icon: User },
];

export default function AppNav() {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const masquerFab = pathname.startsWith('/lieux/') || pathname === '/carte';
  const [sigActif, setSigActif] = useState(false);

  useEffect(() => {
    api.sigStatus().then(res => {
      if (res?.acces) setSigActif(true);
    }).catch(() => {});
  }, []);

  return (
    <>
      {/* En-tête desktop */}
      <header className="entete">
        <div className="entete-inner">
          <NavLink to="/dashboard" className="logo">
            <span className="logo-marque"><MapPinned size={20} /></span>
            {APP_NAME}
          </NavLink>
          <nav className="entete-nav" aria-label="Navigation principale">
            <NavLink to="/lieux">Mes lieux</NavLink>
            {LIENS.slice(1).map(l => <NavLink key={l.to} to={l.to}>{l.label}</NavLink>)}
            {sigActif && <NavLink to="/sig">SIG</NavLink>}
          </nav>
          <button className="btn btn-primaire" onClick={() => navigate('/lieux/nouveau')}>
            <Plus size={18} /> Ajouter un lieu
          </button>
        </div>
      </header>

      {/* Navigation inférieure mobile */}
      <nav className="nav-bas" aria-label="Navigation">
        {LIENS.map(({ to, label, icon: Icone }) => (
          <NavLink key={to} to={to} className={({ isActive }) => `nav-bas-lien ${isActive ? 'actif' : ''}`}>
            <Icone size={22} aria-hidden="true" />
            <span>{label}</span>
          </NavLink>
        ))}
        {sigActif && (
          <NavLink to="/sig" className={({ isActive }) => `nav-bas-lien ${isActive ? 'actif' : ''}`}>
            <Layers size={22} aria-hidden="true" />
            <span>SIG</span>
          </NavLink>
        )}
      </nav>

      {!masquerFab && (
        <button className="fab" onClick={() => navigate('/lieux/nouveau')} aria-label="Ajouter un lieu">
          <Plus size={26} />
        </button>
      )}
    </>
  );
}
